export const getFullYear = (date: Date): number => new Date(date).getFullYear();
